// extracted by mini-css-extract-plugin
export default {"title":"Title_title__Let3M","not-home":"Title_not-home__fR9L6"};